import React, { useState } from "react";
import CtaOne from "@components/CTA/CtaOne";

const NavCard = ({ activeNav, cardsData, noCTA = false }) => {
  const [activeTab, setActiveTab] = useState(activeNav);
  return (
    <div className="w-full px-4 sm:px-8 xl:px-16 py-10 xl:py-20 flex flex-col justify-center">
      <div className="flex flex-wrap justify-center items-center gap-y-2 gap-x-4 sm:gap-16 border border-gray-600 py-4 rounded-full">
        {Object.keys(cardsData).map((item, index) => {
          return (
            <div
              key={index}
              onClick={() => setActiveTab(item)}
              className={`text-md sm:text-xl flex items-center gap-2 cursor-pointer ${
                activeTab === item ? "text-violet-500" : "text-gray-800"
              }`}
            >
              {item}
            </div>
          );
        })}
      </div>
      <div className="mt-8 sm:mt-14 px-2">
        <CtaOne
          heading3={cardsData[activeTab].title}
          paragraph={cardsData[activeTab].description || ""}
          paragraphStyling={``}
          buttonPrimaryText={!noCTA ? `Learn More` : ""}
          buttonPrimaryUrl={!noCTA ? cardsData[activeTab].buttonPrimaryUrl : ""}
        />
      </div>
    </div>
  );
};

export default NavCard;
